import { render, staticRenderFns } from "./ListHotelRoomType.vue?vue&type=template&id=73d524a5&"
import script from "./ListHotelRoomType.vue?vue&type=script&lang=js&"
export * from "./ListHotelRoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports